import { render, staticRenderFns } from "./Basket.vue?vue&type=template&id=403940f0&scoped=true&"
import script from "./Basket.vue?vue&type=script&lang=ts&"
export * from "./Basket.vue?vue&type=script&lang=ts&"
import style0 from "./Basket.vue?vue&type=style&index=0&id=403940f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403940f0",
  null
  
)

export default component.exports